import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Genomii_logo.svg';
import { Instagram, Facebook, Linkedin } from 'react-bootstrap-icons';
import youtubeIcon from '../assets/vectors/footer_youtube1.svg'; 

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-6">
      <div className="container mx-auto px-6">
        {/* Logo above the divider */}
        <div className="flex justify-start mb-4">
          <Link to="/">
            <img src={logo} alt="Genomii.ai Logo" className="h-10" />
          </Link>
        </div>
        
        {/* Divider */}
        <hr className="border-t border-gray-300 my-4" />
        
        {/* Content below the divider */}
        <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start">
          {/* Social icons */}
          <div className="flex space-x-4 mb-4 sm:mb-0">
  <a href="https://www.instagram.com/genomii.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors" aria-label="Instagram">
    <Instagram size={24} />
  </a>
  <a href="https://www.facebook.com/genomiiai" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors" aria-label="Facebook">
    <Facebook size={24} />
  </a>
  <a href="https://www.linkedin.com/company/genomii/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors" aria-label="LinkedIn">
    <Linkedin size={24} />
  </a>
  <a
              href="https://www.youtube.com/@SallyTheDnaDiva"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-800 transition-colors" // Apply similar styling
              aria-label="YouTube" // Add accessibility label
            >
              <img
                src={youtubeIcon}
                alt="YouTube" // Add alt text
                className="h-6 w-6" // Set size to match other icons (h-6/w-6 is often 24px in Tailwind)
              />
            </a>
  
</div>
          
          {/* Copyright text */}
          <div className="text-gray-700 text-sm">
            <p>Genomii Health Guide</p>
            <p>All rights reserved ©Genomii.ai {currentYear}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;